import { StateCreator } from 'zustand';

import { PreferencesParam } from 'src/enums/PreferencesParam';
import { preferencesService } from 'src/services/preferences/preferencesService';

export interface PreferencesSlice {
  language: string;
  setLanguage: (language: string) => void;
}

export const preferencesSlice: StateCreator<
  PreferencesSlice,
  [],
  [],
  PreferencesSlice
> = (set) => ({
  language: preferencesService.get(PreferencesParam.LANGUAGE) as string,
  setLanguage: (language: string) => set({ language }),
});
